module.exports = __webpack_public_path__ + "assets/images/vector-fluxo-healthid-lab-com.28c38f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vector-fluxo-healthid-lab-com.png
// module id = 221
// module chunks = 1